import axios, { AxiosResponse } from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { getApiLink } from '../api';
import { useData } from '../hooks/useData';
import { NewsArticleLikeDislikeRequest } from '../apiSchema';

const defaultData: boolean | null = null;

async function getLikeDislike(newsArticleId: number): Promise<boolean | null> {
    const response: AxiosResponse<boolean | null> = await axios.get(getApiLink('NewsArticle/GetLikeDislike', { newsArticleId }));
    return response.data;
}

async function saveLikeDislike(request: NewsArticleLikeDislikeRequest): Promise<void> {
    await axios.post(getApiLink('NewsArticle/SaveLikeDislike'), request);
}

async function removeLikeDislike(newsArticleId: number): Promise<void> {
    await axios.delete(getApiLink('NewsArticle/RemoveLikeDislike', { newsArticleId }));
}

export default function useNewsArticleFeedback(articleId: number) {
    const { data, isLoading, reFetch } = useData(defaultData, getLikeDislike, articleId);
    const [isLiked, setIsLiked] = useState<boolean | null>(null);

    useEffect(() => {
        if (!isLoading) {
            setIsLiked(data);
        }
    }, [isLoading, data]);

    const toggleLikeFeedback = useCallback(
        async (newsArticleId: number, newIsLiked: boolean | null) => {
            setIsLiked(newIsLiked);

            try {
                if (newIsLiked === null) {
                    await removeLikeDislike(newsArticleId);
                } else {
                    await saveLikeDislike({
                        newsArticleId,
                        isLiked: newIsLiked
                    });
                }
            } catch (error) {
                reFetch();
            }
        },
        [reFetch]
    );

    return {
        isLiked,
        isLoading,
        toggleLikeFeedback
    };
}
